import { Card, CardBody, CardHeader, Divider } from "@nextui-org/react";
import InlineEditInput from "../../../../elements/InlineEditInput";
import { updatePerusahaan } from "../../../../../services/api";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

export default function CompanySection({ className, dataCompany, mutate }) {
  const { id } = useParams();

  function onSubmitName(data) {
    const name = { name: data.text };

    try {
      const response = updatePerusahaan(id, name);
      console.log(response, "success");
      mutate();
    } catch (error) {
      toast.error("Gagal mengupdate nama perusahaan");
    }
  }

  function onSubmitAddress(data) {
    const name = { alamatKantor: data.text };

    try {
      const response = updatePerusahaan(id, name);
      mutate();
      console.log(response, "success");
    } catch (error) {
      toast.error("Gagal mengupdate alamat perusahaan");
    }
  }

  function onSubmitNPWP(data) {
    const name = { npwp: data.text };
    try {
      const response = updatePerusahaan(id, name);
      mutate();
      console.log(response, "success");
    } catch (error) {
      toast.error("Gagal mengupdate NPWP");
    }
  }

  function onSubmitNIB(data) {
    const name = { nib: data.text };
    try {
      const response = updatePerusahaan(id, name);
      mutate();
      console.log(response, "success");
    } catch (error) {
      toast.error("Gagal mengupdate NIB");
    }
  }

  function onSubmitKodeDBKlh(data) {
    const name = { kodeDBKlh: data.text };
    try {
      const response = updatePerusahaan(id, name);
      mutate();
      console.log(response, "success");
    } catch (error) {
      toast.error("Gagal mengupdate Kode DB-KLH");
    }
  }

  function onSubmitAlamatGudang(data) {
    const name = { alamatGudang: data.text };
    try {
      const response = updatePerusahaan(id, name);
      mutate();
      console.log(response, "success");
    } catch (error) {
      toast.error("Gagal mengupdate Kode DB-KLH");
    }
  }

  const data = [
    {
      label: "Nama Perusahaan",
      value: <InlineEditInput value={dataCompany?.company?.name} onSubmit={onSubmitName} />,
    },
    {
      label: "Alamat Kantor Pusat",
      value: <InlineEditInput multiline value={dataCompany?.company?.alamatKantor} onSubmit={onSubmitAddress} />,
    },
    {
      label: "Nomor Telepon",
      value: <span className="text-sm font-medium">{dataCompany?.company?.telpKantor}</span>,
    },
    {
      label: "Nomor Fax",
      value: <span className="text-sm font-medium">{dataCompany?.company?.faxKantor}</span>,
    },
    {
      label: "NPWP",
      // 'value': <span className='text-sm font-medium'>{dataCompany?.company?.npwp}</span>
      value: <InlineEditInput value={dataCompany?.company?.npwp} onSubmit={onSubmitNPWP} />,
    },
    {
      label: "Nomor Induk Berusaha",
      // 'value': <span className='text-sm font-medium'>{dataCompany?.company?.nomorInduk}</span>
      value: <InlineEditInput value={dataCompany?.company?.nib} onSubmit={onSubmitNIB} />,
    },
    {
      label: "Kode DB-KLH",
      // 'value': <span className='text-sm font-medium'>{dataCompany?.company?.nomorInduk}</span>
      value: <InlineEditInput value={dataCompany?.company?.kodeDBKlh} onSubmit={onSubmitKodeDBKlh} />,
    },
    {
      label: "Alamat Gudang (Produsen)",
      // 'value': <span className='text-sm font-medium'>{dataCompany?.company?.nomorInduk}</span>
      value: <InlineEditInput multiline value={dataCompany?.company?.alamatGudang} onSubmit={onSubmitAlamatGudang} />,
    },
  ];

  return (
    <Card className={className} radius="sm">
      <CardHeader>
        <p className="text-md">Data Perusahaan</p>
      </CardHeader>
      <Divider />
      <CardBody>
        <div className="flex flex-col gap-3">
          {data?.map((item, index) => (
            <div key={index} className="flex flex-col">
              <span className="text-xs text-ink-400">{item.label}</span>
              {item.value}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}
